export default function BidFacebookIcon() {
  return (
    <>
      <div className="social_media_icon">
        <a href="https://www.facebook.com/bidfta/">
          <svg
            width="8"
            height="17"
            viewBox="0 0 8 17"
            fill="#FECE62"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M7.68263 5.60575H5.06619V3.88975C5.06619 3.24531 5.49331 3.09507 5.79414 3.09507C6.09428 3.09507 7.64053 3.09507 7.64053 3.09507V0.262L5.09768 0.252075C2.27488 0.252075 1.63249 2.36507 1.63249 3.71726V5.60575H0V8.52506H1.63249C1.63249 12.2716 1.63249 16.7857 1.63249 16.7857H5.06619C5.06619 16.7857 5.06619 12.2271 5.06619 8.52506H7.38316L7.68263 5.60575Z" />
          </svg>
        </a>
      </div>
    </>
  )
}
